import { Modal } from 'flowbite-react';
import React, { useContext, useEffect, useState } from 'react'
import ModalGreenButton from './ModalGreenButton';
import Loading from './Loading';

import MyNewsContext from '../context/NewsContext';

const ModalNews = ({ isModalNewsOpen, setIsModalNewsOpen }) => {
    const { newN, image, getFile, loading } = useContext(MyNewsContext);

    const [dateFormated, setDateFormated] = useState('');



    useEffect(() => {
        const newDate = new Date(newN.newCreationDate);
        const options = { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' };
        const newDateFormated = newDate.toLocaleDateString('es-ES', options);
        setDateFormated(newDateFormated.charAt(0).toUpperCase() + newDateFormated.slice(1));
    }, [newN]);

    

    return (
        <Modal show={isModalNewsOpen} position="top-center" style={{ display: 'flex', alignItems: 'center'}}>
            <div className='pb-3 modal relative' style={{ maxHeight: '95vh', overflowY: 'scroll', width: '100%' }}>
                <div className='relative'>
                    <div className='absolute bottom-0 left-0'>
                        <div className='bg-[#0eaf58] text-white p-2 rounded-tr-2xl'>
                            <p>{dateFormated}</p>
                        </div>

                    </div>
                    <img className='mx-auto w-full rounded-t-lg' src={image} alt="Imagen Noticia" />
                    <div className='absolute top-0 right-0 p-2'>
                        <button onClick={() => setIsModalNewsOpen(false)} className='pb-5 ml-3 '>
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="white" className="w-6 h-6">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                    </div>
                </div>
                <div className='flex flex-col pt-3 px-6 '>
                    <div className='mb-3 pb-2 text-xl font-mono uppercase text-center'>
                        <p>{newN.newTitle}</p>
                    </div>

                    <div className='mb-3'>
                        <div className='font-light text-justify break-words mb-3'>
                            {newN.newDescription.split('\r\n').map((item, i) => {
                                return <span key={i}>{item}<br /></span>
                            })}
                        </div>
                    </div>
                    <div className='w-[40%] mx-auto space-y-2'>
                        {loading ? <Loading isLoading={true} /> : newN.newDocumentPath !== null && <ModalGreenButton onClick={() => getFile(newN.newDocumentPath)} text='Descargar Documento' />}
                        <ModalGreenButton onClick={() => setIsModalNewsOpen(false)} text='Cerrar' />
                    </div>
                </div>
            </div>

        </Modal>
    );
}

export default ModalNews;